var _defs, _rect, _rect2, _rect3, _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAitechiesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AI Techies") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1A0B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#06000F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mark",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7C3AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#EC4899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F59E0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "shine",
    cx: "22%",
    cy: "18%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edge",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "url(#shine)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 254,
    height: 254,
    rx: 59,
    fill: "none",
    stroke: "url(#edge)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mark)",
    d: "M62 200 H102 L112 172 H144 L154 200 H194 L138 56 H118 Z M122 142 H134 L128 110 Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 64,
    r: 14,
    fill: "#22D3EE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 64,
    r: 22,
    fill: "none",
    stroke: "#22D3EE",
    strokeOpacity: 0.45,
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitechiesLogo);
export default __webpack_public_path__ + "static/media/aitechies-logo.22257834e9eb6684dfeecca0049493a2.svg";
export { ForwardRef as ReactComponent };